import React from 'react';
import { useFormikContext } from 'formik';
import { countBy } from 'lodash';
import { RoleService } from 'Services';
import { QF_TENANTS } from 'Hooks/rule-quickfilters/helper';
import useGetRuleQuickFilters from 'Hooks/rule-quickfilters';
import useGetTenantGroupTenantsColumns from 'Hooks/useGetTenantGroupTenantsColumns';
import Table from 'Components/Table';

const TenantCheckboxTable = ({ tableName }: TenantCheckboxTableProps) => {
    const { values, submitForm } = useFormikContext<TenantCheckboxTableForm>();

    const qfHook = useGetRuleQuickFilters({
        quickFilters: [QF_TENANTS.id, 'tenantName', 'description'],
        initialFilters: [
            {
                id: QF_TENANTS.id,
                activeId: []
            }
        ]
    });
    const numOfSelectedTenants = countBy(values.rows, (row) => row.isSelected).true;
    const columns = useGetTenantGroupTenantsColumns();
    let noDataMessage = tableName === 'addTenantTable' ? 'addTenantTableEmptyMsg' : 'removeTenantTableEmptyMsg';

    if (!RoleService.hasTenantGroupWriteAccess) {
        noDataMessage = 'noTenantMsg';
    }

    return (
        <Table
            // tableName is used to control the message row that shows # of selected tenants
            tableName={tableName}
            showMultiSort
            showRichFilter
            showExpandableSearch
            pathToIdOnDataObj={QF_TENANTS.id}
            initialState={{
                sortBy: [{ id: QF_TENANTS.id, desc: false }],
                globalFilter: {
                    quickFilters: qfHook.initialQuickFilters
                }
            }}
            quickFilters={qfHook.filters}
            dataTestId={tableName}
            noDataMessage={noDataMessage}
            columns={columns}
            clickableRow
            data={values.rows}
            enablePagination
            selectedRows={numOfSelectedTenants}
            submitForm={submitForm}
        />
    );
};

export default TenantCheckboxTable;
